export const LOGIN_FIELDS_NAME = {
  email: "email",
  password: "password",
};
